import styled from 'styled-components';
import { theme } from '@jadwalh/ui';

export const CheckboxWrapper = styled.div`
  margin-bottom: ${theme.space_size};
  label {
    display: flex;
    gap: ${theme.space_size};
    align-items: flex-start;
    font-weight: 600;
    align-items: center;

    p {
      margin: 0 !important;
      font-size: 14px !important;
    }
  }
  input[type='checkbox'] {
    width: 16px;
    height: 16px;
    appearance: none;
    border: 1px solid ${theme.colours.blackText};
    border-radius: 4px;
    background-color: #fff;
    cursor: pointer;
    outline: none;
    transition: background-color 0.3s ease, border-color 0.3s ease;
  }

  input[type='checkbox']:checked {
    &::after {
      content: '\u2714';
      color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: ${theme.colours.blackText} !important;
      border: 1px solid ${theme.colours.blackText};
      border-radius: 4px !important;
      width: 13px;
      height: 12px;
      border: 1px solid ${theme.colours.blackText} !important;
      font-size: 8px;
      margin-top: -1px;
      margin-right: -2px;
    }
  }
`;
